import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavHeader from "../components/NavHeader";
import api from "../api/api";

const ResetPassword = () => {
  const [matricNumber, setMatricNumber] = useState("")
  const [btnText, setBtnText] = useState("Reset");
  const [loading, setLoading] = useState(false);
  const [alertClose,setAlertClose] = useState(false);

  const handleForgetPassword = async(e) => {
    e.preventDefault()
    const trimmed = matricNumber.trim().toUpperCase();
    if (!trimmed) return;

    const loadingToast = toast.loading("Please wait...")
    setLoading(true);
    try {
      setBtnText("Please wait...")
      const res = await api.post("/students/students/forgot-password/", {
        identifier: trimmed,
      })
      console.log("response", res)
      toast.dismiss(loadingToast);
      toast.success("Successful")
      setAlertClose(true)
      setMatricNumber("")
      setBtnText("Reset")
      setLoading(false)
    } catch (error) {
      toast.dismiss(loadingToast)
      setLoading(false)
      setBtnText("Failed, Try again")
      
    }
  }

  return (
    <>
      <NavHeader />
      <div class="account-body">
        <div class="container">
          <div class="row vh-100 ">
            <div class="col-12 align-self-center">
              <div class="auth-page">
                <div class="card auth-card shadow-lg">
                  <div class="card-body">
                    <div class="px-3">
                      <div class="text-center auth-logo-text">
                        <h4 class="mb-3 mt-5">Forgot Password</h4>
                        <p class="text-muted mb-0">
                          Enter your Email and instructions will be sent to you!
                        </p>
                      </div>

                      <form
                        class="form-horizontal auth-form my-4"
                        onSubmit={handleForgetPassword}
                      >
                        {alertClose && 
                        <div className="alert dspg-success alert-dismissible fade show">
                        <h4 class="alert-heading">Check your email</h4>
                          <p>We sent a password reset link to your email</p>
                          <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={() => setAlertClose(false)}>
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                        }
                        <div class="form-group">
                          <label for="username">Matric Number</label>
                          <div class="input-group mb-3">
                            <span class="auth-form-icon">
                              <i class="dripicons-mail"></i>
                            </span>
                            <input
                              type="matricNumber"
                              class="form-control"
                              placeholder="Enter your Matric number"
                              value={matricNumber}
                              onChange={(e) => setMatricNumber(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div class="form-group mb-0 row">
                          <div class="col-12 mt-2">
                            <button
                              class="btn btn-gradient-primary btn-round btn-block waves-effect waves-light"
                              type="submit"
                              disabled={loading}
                            >
                              {btnText} <i class="fas fa-sign-in-alt ml-1"></i>
                            </button>
                          </div>
                        </div>
                        <ToastContainer />
                      </form>
                    </div>

                    <div class="m-3 text-center text-muted">
                      <p class="">
                        <Link to="/login" class="text-primary ml-2">
                          Login here
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
